export interface RecommendationsFormProps {
  mockTestId: number;
  onComplete: () => void;
}

export interface RecommendationsFormValues {
  mathScoreGoal: string;
  verbalScoreGoal: string;
  studyArea: string;
  degreeType: string;
  practiceTestFeeling: string;
}

export enum StudyAreas {
  SCIENCE = 'SCIENCE',
  SOCIAL_SCIENCE = 'SOCIAL_SCIENCE',
  HUMANITIES = 'HUMANITIES',
  BUSINESS = 'BUSINESS',
  LAW = 'LAW'
}

export enum DegreeTypes {
  MASTERS = 'MASTERS',
  DOCTORATE = 'DOCTORATE',
  OTHER = 'OTHER'
}
